import React, { useEffect, useState } from "react";
import DashboardHeader from "../../../Components/header/DashboardHeader";
import { Breadcrumb } from "react-bootstrap";
import "../Overview/LiveDetail.css";
import { CiSearch } from "react-icons/ci";
import { live_camera, live_grp_one } from "../../../assets";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { IoEyeOutline } from "react-icons/io5";
import { useNavigate } from "react-router";
import { liveListApi } from "../../../services/goLive";
import { Link, useSearchParams } from "react-router-dom";
import useDebounce from "../../../hooks/useDebounce";
import useShimmer from "../../../hooks/useShimmer";
import GroupsListingShimmer from "../../../shimmer/groups/GroupsListingShimmer";
import { formatDateTime, isoTimeFormat } from "../../../utils/dateTimeFormat";
import { FaArrowLeft } from "react-icons/fa";

const LiveDetail = () => {
  const navigate = useNavigate();
  const [searchParam, setSearchParam] = useSearchParams();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(null);
  const [liveListgroup, setLiveListGroup] = useState([]);
  const [showShimmer, setShowShimmer] = useShimmer(GroupsListingShimmer);
  const debouncedValue = useDebounce(search, 300);
  console.log('liveListgroup', liveListgroup)
  const fetchingLiveListgroupHandler = async (reset = true) => {
    try {
      setShowShimmer(true);
      const { data } = await liveListApi({
        type: "",
        pagination: "true",
        // search: debouncedValue,
        limit: 30,
        page: page,
      });
      // console.log('data', data)
      const { data: liveListGroup, success, message, meta } = data;
      if (success) {
        setTotal(meta?.totalRecords);
        setPage(meta?.page);
        if (reset) {
          setLiveListGroup(liveListGroup || []);
        } else {
          setLiveListGroup((prev) => [...prev, ...(liveListGroup || [])]);
        }
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setShowShimmer(false);
    }
  };

  useEffect(() => {
    fetchingLiveListgroupHandler();
  }, [searchParam, debouncedValue]);

  useEffect(() => {
    if (page > 1) {
      fetchingLiveListgroupHandler(false);
    }
  }, [page]);

  // console.log(liveListgroup, "liveListgroup");

  return (
    <>
      <DashboardHeader title={"Overview"} />

      <div className="live_detail_parent">
        <div className="live_detail_header">
          <ul className="_breadcrumb">
            <li className="__breadcrumb_group">
              <Link to={-1}><FaArrowLeft className="backarrow_grp_detail" /></Link>
            </li>
            <li>
              <span>Go Live</span>
            </li>
          </ul>

          <div className="search_overview">
            <CiSearch />

            <input
              type="text"
              className="input form-control"
              placeholder="Search here"
            />
          </div>
        </div>

        {liveListgroup && liveListgroup?.length > 0 ? liveListgroup?.map((data, ind) => (
          <div key={ind} className="live_detail_contents">
            <div className="Environmental_Science_detail">
              <img src={data?._group?.coverImage} />
              <div className="Environmental_Science_content">
                <b>{data?._group?.name || "---"}</b>
                <p>
                  <MdOutlineCalendarMonth />{" "}
                  <span>
                    {data?.startDateTime
                      ? formatDateTime(data?.startDateTime, "date")
                      : ""}{" "}
                    |
                  </span>
                  <span className="time">
                    {data?.startDateTime
                      ? formatDateTime(data?.startDateTime, "time")
                      : ""}
                  </span>
                  <IoEyeOutline className="eye_icon" />
                  {/* <span>25-04-2025</span> */}
                </p>
              </div>
            </div>
            <div className="btn_wraper">
              <button
                type="button"
                className="view"
                onClick={() =>
                  navigate(`/dashboard/group/detail/${data?._group?._id}`)
                }
              >
                View
              </button>
              <button
                type="button"
                onClick={() => {
                  window.open(data?.event?.meetLink, "_blank");
                }}
                className="join"
              >
                Join <img src={live_camera} className="camera" />
              </button>
            </div>
          </div>
        )) : <div className="text-center"><h4>No data found</h4></div>}
        {/* <div className="live_detail_contents">
          <div className="Environmental_Science_detail">
            <img src={live_grp_one} />
            <div className="Environmental_Science_content">
              <b>Environmental Science</b>
              <p>
                <MdOutlineCalendarMonth /> <span>25-04-2025 |</span>
                <span className="time">5:30 PM</span>
                <IoEyeOutline className="eye_icon" /> <span>25-04-2025</span>
              </p>
            </div>
          </div>
          <div className="btn_wraper">
            <button type="button" className="view">
              View
            </button>
            <button
              type="button"
              onClick={() => {
                navigate("/dashboard/overview/go-live");
              }}
              className="join"
            >
              Join <img src={live_camera} className="camera" />
            </button>
          </div>
        </div>

        <div className="live_detail_contents">
          <div className="Environmental_Science_detail">
            <img src={live_grp_one} />
            <div className="Environmental_Science_content">
              <b>Environmental Science</b>
              <p>
                <MdOutlineCalendarMonth /> <span>25-04-2025 |</span>
                <span className="time">5:30 PM</span>
                <IoEyeOutline className="eye_icon" /> <span>25-04-2025</span>
              </p>
            </div>
          </div>
          <div className="btn_wraper">
            <button type="button" className="view">
              View
            </button>
            <button type="button" className="join">
              Join <img src={live_camera} className="camera" />
            </button>
          </div>
        </div>

        <div className="live_detail_contents">
          <div className="Environmental_Science_detail">
            <img src={live_grp_one} />
            <div className="Environmental_Science_content">
              <b>Environmental Science</b>
              <p>
                <MdOutlineCalendarMonth /> <span>25-04-2025 |</span>
                <span className="time">5:30 PM</span>
                <IoEyeOutline className="eye_icon" /> <span>25-04-2025</span>
              </p>
            </div>
          </div>
          <div className="btn_wraper">
            <button type="button" className="view">
              View
            </button>
            <button type="button" className="join">
              Join <img src={live_camera} className="camera" />
            </button>
          </div>
        </div>

        <div className="live_detail_contents">
          <div className="Environmental_Science_detail">
            <img src={live_grp_one} />
            <div className="Environmental_Science_content">
              <b>Environmental Science</b>
              <p>
                <MdOutlineCalendarMonth /> <span>25-04-2025 |</span>
                <span className="time">5:30 PM</span>
                <IoEyeOutline className="eye_icon" /> <span>25-04-2025</span>
              </p>
            </div>
          </div>
          <div className="btn_wraper">
            <button type="button" className="view">
              View
            </button>
            <button type="button" className="join">
              Join <img src={live_camera} className="camera" />
            </button>
          </div>
        </div>

        <div className="live_detail_contents">
          <div className="Environmental_Science_detail">
            <img src={live_grp_one} />
            <div className="Environmental_Science_content">
              <b>Environmental Science</b>
              <p>
                <MdOutlineCalendarMonth /> <span>25-04-2025 |</span>
                <span className="time">5:30 PM</span>
                <IoEyeOutline className="eye_icon" /> <span>25-04-2025</span>
              </p>
            </div>
          </div>
          <div className="btn_wraper">
            <button type="button" className="view">
              View
            </button>
            <button type="button" className="join">
              Join <img src={live_camera} className="camera" />
            </button>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default LiveDetail;
